import {useQuery} from "@tanstack/react-query";
import {authTelegramGet} from "../api/auth/authTelegramGet.ts";

export const useTelegramLink = () => useQuery({
    queryKey: ['authTelegram'],
    queryFn: () => authTelegramGet().then((r) => r.payload)
})